/*=========================================================================================
  File Name: moduleCentreHospitalierState.js
  Description: Centre Hospitalier Module State
  ----------------------------------------------------------------------------------------
==========================================================================================*/

export default {
  centre_hospitaliers: []
}
